import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { InstagramIcon, TelegramIcon, WhatsAppIcon, MenuIcon, CloseIcon } from "./Icons";
import { WA_URL, TG_URL, IG_URL, PHONE_RAW, PHONE_DISPLAY } from "../config/constants";
import "./Navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation("common");

  const switchLang = (lng) => i18n.changeLanguage(lng);
  const lang = i18n.language;

  useEffect(() => {
    let lastY = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (y < 60) {
        setScrolled(true);
      } else if (y > lastY) {
        setScrolled(false);
      } else {
        setScrolled(true);
      }
      lastY = y;
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  const links = [
    { to: "/listings",      label: t("nav.listings") },
    { to: "/international", label: t("nav.international") },
    { to: "/blog",          label: t("nav.blog") },
    { to: "/about",         label: t("nav.about") },
    { to: "/contact",       label: t("nav.contact") },
  ];

  return (
    <>
      <header className={`navbar ${scrolled ? "scrolled" : ""} ${open ? "menu-open" : ""}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo" onClick={() => setOpen(false)}>
            <img src="/logo-icon.webp" alt="" className="nav-logo-icon" fetchpriority="high" width="65" height="38" />
            <img src="/logo-text.webp" alt="ProNet Real Estate" className="nav-logo-text" fetchpriority="high" width="69" height="28" />
          </Link>

          <nav className="nav-links-desktop">
            {links.map(l => (
              <Link key={l.to} to={l.to} className={`nav-link ${pathname.startsWith(l.to) ? "active" : ""}`}>
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="nav-right">
            <div className="lang-toggle">
              <button className={lang === "en" ? "active" : ""} onClick={() => switchLang("en")}>EN</button>
              <button className={lang === "ru" ? "active" : ""} onClick={() => switchLang("ru")}>RU</button>
            </div>
            <div className="nav-socials">
              <a href={IG_URL} target="_blank" rel="noreferrer" className="nav-social" aria-label="Instagram">
                <InstagramIcon size={17} />
              </a>
              <a href={TG_URL} target="_blank" rel="noreferrer" className="nav-social" aria-label="Telegram">
                <TelegramIcon size={17} />
              </a>
              <a href={WA_URL} target="_blank" rel="noreferrer" className="nav-social" aria-label="WhatsApp">
                <WhatsAppIcon size={17} />
              </a>
            </div>
            <Link to="/contact" className="nav-cta">{t("nav.cta")}</Link>
          </div>

          <button className="nav-burger" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </header>

      <div className={`mobile-menu ${open ? "open" : ""}`}>
        <nav className="mobile-nav">
          {links.map((l, i) => (
            <Link
              key={l.to}
              to={l.to}
              className={`mobile-nav-link ${pathname.startsWith(l.to) ? "active" : ""}`}
              onClick={() => setOpen(false)}
              style={{ animationDelay: `${i * 0.08}s` }}
            >
              <span className="mobile-nav-num">0{i + 1}</span>
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="mobile-menu-footer">
          <div className="mobile-socials">
            <a href={IG_URL} target="_blank" rel="noreferrer" className="mobile-social">
              <InstagramIcon size={20} />
              <span>Instagram</span>
            </a>
            <a href={TG_URL} target="_blank" rel="noreferrer" className="mobile-social">
              <TelegramIcon size={20} />
              <span>Telegram</span>
            </a>
            <a href={WA_URL} target="_blank" rel="noreferrer" className="mobile-social">
              <WhatsAppIcon size={20} />
              <span>WhatsApp</span>
            </a>
          </div>
          <a href={`tel:${PHONE_RAW}`} className="mobile-phone">{PHONE_DISPLAY}</a>
        </div>
      </div>
    </>
  );
}
